import { ApolloError, useSuspenseQuery } from '@apollo/client';
import {
  GetPartnerCompensationDocument,
  GetPartnerCompensationQuery,
} from '@storefront/data-commerce';

export const useGetPartnerCompensation = (hpChannelCode: string) => {
  const { data, error } = useSuspenseQuery<GetPartnerCompensationQuery>(
    GetPartnerCompensationDocument,
    {
      variables: {
        hpChannelCode,
      },
      skip: !hpChannelCode,
    }
  );

  if (!hpChannelCode) {
    const error = new ApolloError({
      errorMessage: 'An error occurred',
    });
    return { data: null, error };
  }

  return {
    data,
    error,
  };
};

export default useGetPartnerCompensation;
